import { useState } from "react";

import { Box, Typography } from "@mui/material";

import { ChartPieSliceIcon } from "@phosphor-icons/react/dist/ssr";

import { DiagramModal, TabHeader } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";
import { Diagram } from "@/types";

import { DiagramItem } from "./index";

const Diagrams = () => {
  const { lessonInteractionProfile } = useLesson();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDiagram, setSelectedDiagram] = useState<Diagram | null>(null);
  const diagrams =
  lessonInteractionProfile?.realtimeResources?.diagrams?.filter(
      (diagram) => diagram.isApproved
    ) || [];

  const handleOpenModal = (diagram: Diagram) => {
    setSelectedDiagram(diagram);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDiagram(null);
  };

  return (
    <Box
      width="100%"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TabHeader
        title="Diagrams"
        icon={<ChartPieSliceIcon size={16} weight="bold" />}
      />

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
        }}
      >
        {diagrams?.length < 1 ? (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              px: 4,
            }}
          >
            <Typography
              variant="text15B"
              color="textSecondary"
              textAlign="center"
              sx={{ width: "100%" }}
            >
              No diagrams available yet.
            </Typography>
            <Typography
              variant="text13L"
              color="textSecondary"
              textAlign="center"
              sx={{ width: "100%" }}
            >
              Your tutor will add diagrams here to help you understand the
              concepts better.
            </Typography>
          </Box>
        ) : (
          <Box>
            {diagrams.map((diagram, index) => (
              <DiagramItem
                key={diagram.id}
                diagram={diagram}
                index={index}
                onOpenModal={handleOpenModal}
              />
            ))}
          </Box>
        )}
      </Box>
      {selectedDiagram && (
        <DiagramModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          diagram={selectedDiagram}
        />
      )}
    </Box>
  );
};

export default Diagrams;
